// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Printer from "@insite/mobius/Icons/Printer";
import { pipeAndWirePricingContainerStyles } from "@steiner/App/Widgets/Layout/PipeAndWirePricingContainer";
import Subscribe from "@steiner/XDL/Icons/Subscribe";
import UnSubscribe from "@steiner/XDL/Icons/UnSubscribe";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

pipeAndWirePricingContainerStyles.actionsWrapper = {
    css: css`
        display: flex;
        align-items: flex-start;
        gap: 8px 16px;
        margin-bottom: 20px;
        flex-wrap: wrap;

        ${hideElementOnPrint}
    `,
};

pipeAndWirePricingContainerStyles.innerActionsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-left: auto;
        padding-top: 8px;
    `,
};

pipeAndWirePricingContainerStyles.sendSheetAsEmailFormContainer = {
    css: css`
        max-width: 370px;
        width: 100%;

        form {
            display: flex;
            align-items: flex-start;
            gap: 8px;
        }
    `,
};

pipeAndWirePricingContainerStyles.printLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.small,
    },
    icon: {
        iconProps: {
            src: Printer,
        },
    },
};

pipeAndWirePricingContainerStyles.subscribeLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.small,
    },
    icon: {
        iconProps: {
            src: Subscribe,
        },
    },
};

pipeAndWirePricingContainerStyles.unSubscribeLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.small,
    },
    icon: {
        iconProps: {
            src: UnSubscribe,
        },
    },
};
